import React from 'react';
import { Home, FileText, ShoppingCart } from 'lucide-react';

interface BottomNavigationProps {
  activeTab?: 'home' | 'orders' | 'cart';
  onTabChange?: (tab: 'home' | 'orders' | 'cart') => void;
  cartItemCount?: number;
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({
  activeTab = 'home',
  onTabChange,
  cartItemCount = 0
}) => {
  const tabs = [
    {
      id: 'home' as const,
      label: 'Início',
      icon: Home,
    },
    {
      id: 'orders' as const,
      label: 'Pedidos',
      icon: FileText,
    },
    {
      id: 'cart' as const,
      label: 'Carrinho',
      icon: ShoppingCart,
    },
  ];

  const handleTabClick = (tabId: 'home' | 'orders' | 'cart') => {
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t-[1.5px] border-gray-900 z-20 safe-area-bottom">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex items-center justify-around h-16">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;

            return (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className="flex flex-col items-center justify-center gap-1 flex-1 h-full transition-colors relative"
              >
                <div className="relative">
                  <Icon
                    className={`w-5 h-5 transition-colors ${
                      isActive
                        ? 'text-primary-500 stroke-[2.5]'
                        : 'text-gray-500 stroke-[2]'
                    }`}
                  />
                  {tab.id === 'cart' && cartItemCount > 0 && (
                    <span className="absolute -top-2 -right-2 bg-primary-500 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                      {cartItemCount > 9 ? '9+' : cartItemCount}
                    </span>
                  )}
                </div>
                <span
                  className={`text-[12px] font-bold transition-colors ${
                    isActive ? 'text-primary-500' : 'text-gray-600'
                  }`}
                >
                  {tab.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNavigation;
